import React from 'react';

/**
 * BackLink component for navigating back in the browser history.
 */
const BackLink: React.FC = () => {
  return (
    <button
      className="mt-4 text-lg font-light no-underline btn btn-link before:content-['<']"
      type="button"
      onClick={() => window.history.back()}
    >
      Torna indietro
    </button>
  );
};

export default BackLink;
